import React, { lazy } from 'react';
export function BonusSection() {
  const scrollToPurchase = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  const bonuses = [{
    title: 'Plan de Acción 7 Días',
    description: 'Guía de arranque inmediato',
    benefit: 'Sabés exactamente qué aplicar esta semana',
    image: 'https://cdn.magicpatterns.com/uploads/pqUt9eLM4Sxywrp92VoMgn/aed0cdf4-7506-420b-8ad6-b55856cdfc1b-removebg-preview.png'
  }, {
    title: 'Checklist Pre-Salida',
    description: '40 puntos de control',
    benefit: 'Nunca más salís sin algo importante',
    image: 'https://cdn.magicpatterns.com/uploads/maKBzzdFNo8dYiCMRaqbLv/50448abb-b769-4d6d-9531-339882bbfa0c-removebg-preview.png'
  }, {
    title: 'Guía de Rutas por Provincia',
    description: 'Mapa de rutas amateurs',
    benefit: 'Rutas seguras en tu provincia',
    image: 'https://cdn.magicpatterns.com/uploads/geGgS2Kp6pYNqrjLP8u55p/3f079d70-d243-4650-8e96-6e20791dfaf6-removebg-preview.png'
  }, {
    title: 'Tabla de Presupuesto',
    description: 'Calculadora de gastos',
    benefit: 'Detectás dónde estás tirando plata',
    image: 'https://cdn.magicpatterns.com/uploads/jT8FrQhNsm5wcGtLBU4hwM/c7d9e733-5155-489a-8511-5b67c2045717-removebg-preview.png'
  }, {
    title: 'Diario de Rendimiento 30 Días',
    description: 'Sistema de registro',
    benefit: 'Medís tu progreso real semana a semana',
    image: 'https://cdn.magicpatterns.com/uploads/3fHEuYWHRdgSFyd8tnRDsv/def111bc-b8c1-4689-b55c-6408df8c1230-removebg-preview.png'
  }];
  return <section className="bg-gradient-to-b from-gray-900 to-gray-950 text-white py-16 px-4" data-id="element-14">
      <div className="max-w-6xl mx-auto" data-id="element-15">
        <h2 className="text-3xl md:text-4xl font-bold mb-4 text-center" data-id="element-16">
          🎁 5 REGALOS INCLUIDOS HOY
        </h2>
        <p className="text-2xl font-bold text-green-400 text-center mb-12" data-id="element-17">
          GRATIS POR EL DÍA DE HOY
        </p>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8" data-id="element-18">
          {bonuses.map((bonus, index) => <div key={index} className="bg-gray-800 border-2 border-green-600 rounded-lg overflow-hidden hover:border-green-400 transition-all duration-300 cursor-pointer transform hover:scale-105" onClick={scrollToPurchase} data-id="element-19">
              <img src={bonus.image} alt={bonus.title} className="w-full h-auto object-contain" loading="lazy" data-id="element-20" />
              <div className="p-6" data-id="element-21">
                <div className="bg-green-600 text-white text-xs font-bold px-3 py-1 rounded-full inline-block mb-3" data-id="element-22">
                  GRATIS
                </div>
                <h3 className="text-xl font-bold mb-2" data-id="element-23">{bonus.title}</h3>
                <p className="text-gray-400 text-sm mb-2" data-id="element-24">
                  {bonus.description}
                </p>
                <p className="text-green-400 font-semibold text-sm" data-id="element-25">
                  {bonus.benefit}
                </p>
              </div>
            </div>)}
        </div>

        <div className="overflow-x-auto" data-id="element-26">
          <table className="w-full bg-gray-800 border border-gray-700 rounded-lg" data-id="element-27">
            <thead data-id="element-28">
              <tr className="bg-gray-900" data-id="element-29">
                <th className="px-6 py-3 text-left" data-id="element-30">Regalo</th>
                <th className="px-6 py-3 text-left" data-id="element-31">Qué es</th>
                <th className="px-6 py-3 text-left" data-id="element-32">Para qué sirve</th>
              </tr>
            </thead>
            <tbody data-id="element-33">
              {bonuses.map((bonus, index) => <tr key={index} className="border-t border-gray-700" data-id="element-34">
                  <td className="px-6 py-4 font-semibold" data-id="element-35">{bonus.title}</td>
                  <td className="px-6 py-4 text-gray-300" data-id="element-36">
                    {bonus.description}
                  </td>
                  <td className="px-6 py-4 text-gray-300" data-id="element-37">{bonus.benefit}</td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </section>;
}